import { useMemo } from 'react';

import { useCapabilities } from '@hcs/authz';
import { CapabilityKeys } from '@hcs/types';
import { PortfolioFormNotificationTypes } from '@hcs/types';

const PMCapabilityToNotificationType: Partial<
  Record<CapabilityKeys, PortfolioFormNotificationTypes>
> = {
  'portfolio-monitor-mls': PortfolioFormNotificationTypes.Mls,
  'portfolio-monitor-ltv': PortfolioFormNotificationTypes.Ltv,
  'portfolio-monitor-avm': PortfolioFormNotificationTypes.Avm,
  'portfolio-monitor-lien': PortfolioFormNotificationTypes.Lien,
  'portfolio-monitor-nod': PortfolioFormNotificationTypes.Nod,
  'portfolio-monitor-propensity-to-list':
    PortfolioFormNotificationTypes.PropensityToList,
  'portfolio-monitor-propensity-to-refi':
    PortfolioFormNotificationTypes.PropensityToRefi,
};

export const useAccessibleNotifications = () => {
  const capabilitiesQuery = useCapabilities({
    application: ['portfolio'],
  });
  const { data: capabilitiesData } = capabilitiesQuery;
  const notificationTypes = useMemo(() => {
    return capabilitiesData
      ?.map((capability) => {
        const notificationType = PMCapabilityToNotificationType[capability.key];
        return notificationType ? notificationType : null;
      })
      .filter((notificationType) => notificationType !== null);
  }, [capabilitiesData]);
  return {
    ...capabilitiesQuery,
    data: notificationTypes,
  };
};
